<template>
    <div v-if="casasDecimais">
        <v-text-field @focusout="emitirEventoFoco" v-money="moneyConfig" maxLength="15" :key="idCampo" v-bind:value="value" @input="updateValue($event)" v-if="menorPreco"></v-text-field>
        <v-text-field @focusout="emitirEventoFoco" v-currency="valueConfigMD" :key="idCampo" maxLength="15" v-bind:value="value" @input="updateValue($event)" v-else></v-text-field>
    </div>
</template>

<script>
    export default {
        name: 'CampoMoeda',
        props: ['value', 'casasDecimais', 'menorPreco', 'idCampo'],
        data() {
            return {
                moneyConfig: {}
            }
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value)
            },
            emitirEventoFoco(){
                this.$emit('eventoFoco')
            }
        },
        mounted() {
            this.moneyConfig = {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: this.casasDecimais,
                masked: false
            }
        },
        computed: {
            valueConfigMD(){
                return {currency: null, decimalLength: this.casasDecimais}
            }
        }
    }
</script>

<style scoped>

</style>